module.exports = __webpack_public_path__ + "media/images/front/pc/for-doctors/bn_keijinkai-6ee26ecaf5f565eefbea30fe6325010e.png";